/**
 * created by xcc on 2022/5/17
 * 网站扩展字段接口
 */

import request from "../../base/request";

let host = "/cm-sites-pms/website/";

const Apis = {
    getListData: host + "getExtendFieldList", //网站扩展字段列表
    updateExtensionField: host + 'synExtendField', //更新扩展字段
    getWebsites: '/cm-sites-pms/vsbManage/list', //获取站群
}

export const getListData = (body, callBack) => {
    request({url: Apis.getListData, body, callBack});
};
export const updateExtensionField = (body, callBack) => {
    request({url: Apis.updateExtensionField, body, callBack});
};
export const getWebsites = (body, callBack) => {
    request({url: Apis.getWebsites, body, callBack});
};